export default {
  SOME_GETTER(state) {
    return state
  },
}
